import { FC } from 'react'
import { useSelector } from 'react-redux'
import RootState from '../../../../redux/types'
import { FilterSectionTransport } from '../../../../transports/search-result-listing-static-transport'
import { getUserDetailsModel } from '../../../../redux/user/selectors'
import {
    HeaderRow,
    MobileWishlistButton,
    PillWrapper,
    WishlistBadge,
    WishlistIconStyled,
    WishlistIconContainer,
} from './styles'
import FilterPill from '../../../app-components/filter-components/filter-pill'
import SmartSearchPill from '../../../app-components/filter-components/smart-search-pill'
import SortPill from '../../../app-components/filter-components/sort-pill'
import ButtonTransport from '../../../../transports/common/button-transport'

interface Props {
    filterStaticData: FilterSectionTransport
    wishlistButton?: ButtonTransport
    /* Smart search is list-page only; the map page renders this header without it. */
    showSmartSearch?: boolean
}

const FilterHeader: FC<Props> = ({ filterStaticData, wishlistButton, showSmartSearch = false }) => {
    const userDetails = useSelector(getUserDetailsModel)
    const reduxWishlistCount = useSelector((state: RootState) => state.wishlist.count)
    const wishlistCount = reduxWishlistCount ?? userDetails?.favoriteCount ?? 0

    return (
        <HeaderRow>
            <PillWrapper>
                {showSmartSearch && <SmartSearchPill />}
                <FilterPill filterStaticData={filterStaticData} />
                <SortPill filterStaticData={filterStaticData} />
            </PillWrapper>
            {!!wishlistButton?.url && (
                <MobileWishlistButton href={wishlistButton.url} noCrawl={wishlistButton.noCrawl}>
                    <WishlistIconContainer>
                        <WishlistIconStyled />
                        {wishlistCount > 0 && <WishlistBadge>{wishlistCount}</WishlistBadge>}
                    </WishlistIconContainer>
                </MobileWishlistButton>
            )}
        </HeaderRow>
    )
}

export default FilterHeader
